import type { AllRouteEndpoints } from "../routeTypes";
export const appsCatalogsCatalogIdSubscriptionsDeleteAllCacheKeys: AllRouteEndpoints[] = [];
